import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  useTheme,
  Stack,
} from '@mui/material';
import { ChevronLeft, Close as CloseIcon } from '@mui/icons-material';

interface GenericDrawerProps {
  open: boolean;
  onClose: () => void;
  onBack?: () => void;
  actions?: React.ReactNode;
  title: string;
  children: React.ReactNode;
  width?: number | string;
}

const GenericDrawer: React.FC<GenericDrawerProps> = ({
  open,
  onClose,
  onBack,
  title,
  children,
  width = { xs: '100%', sm: 750 },
  actions
}) => {

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width,
        },
      }}
    >
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        {children}
      </Box>

    </Drawer>
  );
};

export default GenericDrawer; 